var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagForReview(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#FF2800"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 14V2M3 7.263c3.273-2.553 5.727 2.553 9 0V1.737c-3.273 2.553-5.727-2.553-9 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "flag-for-review_svg__clip0_2963_3396"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h15v15H0z"
  })))));
}
export default SvgFlagForReview;